module.exports = __webpack_public_path__ + "img/silence.43318685.svg";